module.exports = function() {
  return new Worker(__webpack_public_path__ + "470bc0fe90a84f2090dd.worker.js");
};